import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import isEqual from 'lodash/isEqual'

import { DocTemplateListSchema } from './DocTemplateListSchema'
import { TEMPLATES_LIST_KEY, templatesListQueryOptions } from './query'

export const templatesListRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '/',
    component: lazyRouteComponent(() => import('./TemplatesList')),
    validateSearch: (search) => DocTemplateListSchema.parse(search),
    loaderDeps: ({ search }) => ({
      search,
      isChanged: !isEqual(DocTemplateListSchema.parse({}), search)
    }),
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return context.queryClient.getQueryData([TEMPLATES_LIST_KEY, deps.search]) ?? null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(templatesListQueryOptions(deps.search))
    }
  })
